export default __webpack_public_path__ + "static/6670-14076e175483327ec97837d44433373f.jpg";